// extracted by mini-css-extract-plugin
export default {"wrapper":"GroupPayment-modules__wrapper__DRJkD","show-keyframe":"GroupPayment-modules__show-keyframe__Lqdl7"};